/** React Native's AbortSignal does not implement throwIfAborted or reason. */
export function throwIfAborted(signal) {
    if (!signal.aborted)
        return;
    const error = new Error('The operation was aborted');
    error.name = 'AbortError';
    throw error;
}
